var map = {
	"./a-colour-picker.svg": 69251,
	"./align-center.svg": 71784,
	"./align-left.svg": 77846,
	"./align-right.svg": 13707,
	"./arrow-left.svg": 75651,
	"./arrow.svg": 98245,
	"./audio-pause.svg": 258,
	"./audio-play.svg": 42010,
	"./awards.svg": 86894,
	"./bell.svg": 76970,
	"./bold.svg": 76322,
	"./captain.svg": 55661,
	"./chat.svg": 88088,
	"./check.svg": 13176,
	"./collect.svg": 36025,
	"./comment.svg": 43750,
	"./cross.svg": 99118,
	"./draw.svg": 31233,
	"./edit.svg": 94329,
	"./facebook.svg": 71647,
	"./globe.svg": 27321,
	"./heart.svg": 40274,
	"./hero.svg": 29615,
	"./hexagon.svg": 69595,
	"./import-image.svg": 49136,
	"./inappropriate.svg": 5447,
	"./italic.svg": 14386,
	"./leagues.svg": 74793,
	"./left.svg": 92125,
	"./legend.svg": 26995,
	"./lock.svg": 38611,
	"./logo.svg": 45945,
	"./logout-2.svg": 90224,
	"./logout.svg": 65882,
	"./mail.svg": 98732,
	"./menu.svg": 25177,
	"./minus.svg": 68260,
	"./more.svg": 59029,
	"./music.svg": 73945,
	"./notifications.svg": 79359,
	"./orb-v2.svg": 18389,
	"./orb.svg": 73265,
	"./padlock.svg": 93413,
	"./pencil.svg": 83958,
	"./picture.svg": 29160,
	"./play.svg": 90455,
	"./plus.svg": 97053,
	"./print.svg": 58922,
	"./pro.svg": 10965,
	"./reading-light.svg": 34962,
	"./recruit.svg": 2656,
	"./referral.svg": 5733,
	"./refresh.svg": 92247,
	"./right.svg": 32941,
	"./school.svg": 25355,
	"./search.svg": 86573,
	"./settings.svg": 4296,
	"./sfx.svg": 93073,
	"./shield.svg": 18958,
	"./star.svg": 78545,
	"./text-colour-picker.svg": 68760,
	"./time-travel.svg": 32798,
	"./torch.svg": 51024,
	"./trash.svg": 93755,
	"./trophy.svg": 48080,
	"./twitter.svg": 94686,
	"./underline.svg": 4773,
	"./view.svg": 83624,
	"./whatsapp.svg": 85293,
	"./world.svg": 89862,
	"./zoo.svg": 11617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35558;